"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _repeatInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/repeat");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerTree = exports.BmTree = void 0;

var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@onviobr/element");

var _bmTreeItem = require("./bm-tree-item");

var _bmTreeStore = require("./bm-tree-store");

var _bmTreeDropArea = require("./bm-tree-drop-area");

var _bmTreeModel = require("./bm-tree-model");

var _utils = require("../utils");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t", "\n\t\t"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t", "\n\t\t\t<bm-tree-item\n\t\t\t\ttabindex=\"0\"\n\t\t\t\trole=\"", "\"\n\t\t\t\taria-level=\"", "\"\n\t\t\t\ttitle=\"", "\"\n\t\t\t\tid=\"", "\"\n\t\t\t\t.data-qe-id=\"", "\"\n\t\t\t\t.name=\"", "\"\n\t\t\t\t.subtitle=\"", "\"\n\t\t\t\t.layer=\"", "\"\n\t\t\t\t.showCheckboxes=\"", "\"\n\t\t\t\t.showItemCheckbox=\"", "\"\n\t\t\t\t.selectAsCheck=\"", "\"\n\t\t\t\t.allowSelect=\"", "\"\n\t\t\t\t.subItems=\"", "\"\n\t\t\t\t.leftIcon=\"", "\"\n\t\t\t\t.rightIcon=\"", "\"\n\t\t\t\t.href=\"", "\"\n\t\t\t\t.store=\"", "\"\n\t\t\t\t.allowItemDrag=\"", "\"\n\t\t\t\t.allowDropInto=\"", "\"\n\t\t\t\t.index=\"", "\"\n\t\t\t\t@select=\"", "\"\n\t\t\t\t@check=\"", "\"\n\t\t\t\t@toggle-expand=\"", "\"\n\t\t\t\t@dropped-external-item=\"", "\"\n\t\t\t\t@dropped-moved-item=\"", "\"\n\t\t\t\t@error=\"", "\"\n\t\t\t>\n\t\t\t</bm-tree-item>\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<bm-tree-drop-area .parentId=\"", "\"\n\t\t\t\t\t\t\t\t\t\t\t\t.index=\"", "\"\n\t\t\t\t\t\t\t\t\t\t\t\t.store=\"", "\"\n\t\t\t\t\t\t\t\t\t\t\t\ttabindex=\"-1\"\n\t\t\t\t\t\t\t\t\t\t\t\t@dropped-moved-item=\"", "\">\n\t\t\t</bm-tree-drop-area>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\t--theme-color: #ff8000;\n\t\t--background-color: #f4f5f7;\n\t\t--bm-tree-item-height: 30px;\n\t\t--bm-tree-item-width: auto;\n\t\t--bm-tree-item-font-size: 16px;\n\t\t--bm-tree-item-border;\n\t\t--bm-tree-height: inherit;\n\t\t--bm-tree-width: inherit;\n\t\t--bm-tree-item-padding-right: 7px;\n\t\t--bm-tree-item-text-decoration: none;\n\t\t--bm-tree-item-color: black;\n\t\theight: inherit;\n\t\theight: var(--bm-tree-height, inherit);\n\t\twidth: inherit;\n\t\twidth: var(--bm-tree-width, inherit);\n\t\tdisplay: block;\n\t}\n\t:host .hidden {\n\t\tdisplay: none;\n\t}\n\t:host .drop-area {\n\t\theight: 2px;\n\t}\n\t:host .drop-area.drag-over {\n\t\tbackground: #b2b2b8;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

var BmTree = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmTree, _BlueElement);

  var _super = (0, _createSuper2.default)(BmTree);

  (0, _createClass2.default)(BmTree, null, [{
    key: "is",
    get: function get() {
      return 'bm-tree';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        includeMouseEventOnSelect: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        includeEventDataOnSelect: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        items: {
          type: Object,
          attribute: false,
          reflect: false
        },
        showCheckboxes: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        selectAsCheck: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        allowMultipleSelect: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        allowDragAndDrop: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        store: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);

  function BmTree() {
    var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10;

    var _this;

    (0, _classCallCheck2.default)(this, BmTree);
    _this = _super.call(this);
    _this.includeMouseEventOnSelect = void 0;
    _this.includeEventDataOnSelect = void 0;
    _this.items = void 0;
    _this.showCheckboxes = void 0;
    _this.selectAsCheck = void 0;
    _this.allowMultipleSelect = void 0;
    _this.allowDragAndDrop = void 0;
    _this.store = void 0;
    _this.treeStore = void 0;
    _this.includeMouseEventOnSelect = false;
    _this.items = null;
    _this.showCheckboxes = false;
    _this.selectAsCheck = false;
    _this.allowMultipleSelect = false;
    _this.allowDragAndDrop = false;
    _this.store = null;
    _this.treeStore = new _bmTreeStore.TreeStore();
    _this.renderTreeItem = (0, _bind.default)(_context = _this.renderTreeItem).call(_context, (0, _assertThisInitialized2.default)(_this));
    _this.requestUpdate = (0, _bind.default)(_context2 = _this.requestUpdate).call(_context2, (0, _assertThisInitialized2.default)(_this));
    _this.handleChecked = (0, _bind.default)(_context3 = _this.handleChecked).call(_context3, (0, _assertThisInitialized2.default)(_this));
    _this.handleSelected = (0, _bind.default)(_context4 = _this.handleSelected).call(_context4, (0, _assertThisInitialized2.default)(_this));
    _this.handleExpanded = (0, _bind.default)(_context5 = _this.handleExpanded).call(_context5, (0, _assertThisInitialized2.default)(_this));
    _this.handleKeyDown = (0, _bind.default)(_context6 = _this.handleKeyDown).call(_context6, (0, _assertThisInitialized2.default)(_this));
    _this.handleDroppedExternalItem = (0, _bind.default)(_context7 = _this.handleDroppedExternalItem).call(_context7, (0, _assertThisInitialized2.default)(_this));
    _this.handleDroppedMovedItem = (0, _bind.default)(_context8 = _this.handleDroppedMovedItem).call(_context8, (0, _assertThisInitialized2.default)(_this));
    _this.handleError = (0, _bind.default)(_context9 = _this.handleError).call(_context9, (0, _assertThisInitialized2.default)(_this));
    _this.handleStateChange = (0, _bind.default)(_context10 = _this.handleStateChange).call(_context10, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BmTree, [{
    key: "removeStoreListeners",
    value: function removeStoreListeners(store) {
      store.emitter.removeEventListener(_bmTreeModel.TreeStateChangeType.Visible, this.handleStateChange);
      store.emitter.removeEventListener(_bmTreeModel.TreeStateChangeType.Checked, this.handleStateChange);
      store.emitter.removeEventListener(_bmTreeModel.TreeStateChangeType.Selected, this.handleStateChange);
    }
  }, {
    key: "addStoreListeners",
    value: function addStoreListeners(store) {
      store.emitter.addEventListener(_bmTreeModel.TreeStateChangeType.Visible, this.handleStateChange);
      store.emitter.addEventListener(_bmTreeModel.TreeStateChangeType.Checked, this.handleStateChange);
      store.emitter.addEventListener(_bmTreeModel.TreeStateChangeType.Selected, this.handleStateChange);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$store;

      (0, _get2.default)((0, _getPrototypeOf2.default)(BmTree.prototype), "connectedCallback", this).call(this);
      this.treeStore = (_this$store = this.store) !== null && _this$store !== void 0 ? _this$store : new _bmTreeStore.TreeStore(this.allowMultipleSelect);
      this.addStoreListeners(this.treeStore);
      this.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(BmTree.prototype), "disconnectedCallback", this).call(this);
      this.removeStoreListeners(this.treeStore);
      this.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "shouldUpdate",
    value: function shouldUpdate(changedProps) {
      if (changedProps.has('items') && this.treeStore && this.items) {
        this.treeStore.setStore(this.items);
      }

      if (changedProps.has('store') && this.store) {
        this.removeStoreListeners(this.treeStore);
        this.treeStore = this.store;

        if (this.items) {
          this.treeStore.setStore(this.items);
        }

        this.addStoreListeners(this.treeStore);
      }

      return true;
    }
  }, {
    key: "handleStateChange",
    value: function handleStateChange() {
      this.requestUpdate().catch(console.error);
    }
  }, {
    key: "handleError",
    value: function handleError(e) {
      this.dispatchEvent(new CustomEvent('error', {
        detail: e.detail
      }));
    }
  }, {
    key: "setKeyEventFocusForSiblingItem",
    value: function setKeyEventFocusForSiblingItem(keyCode, treeItems, currentIndex) {
      var newIndex = 0;

      if (keyCode === _utils.KeyCode.End) {
        newIndex = treeItems.length - 1;
      } else if (keyCode === _utils.KeyCode.ArrowUp) {
        newIndex = currentIndex > 0 ? currentIndex - 1 : treeItems.length - 1;
      } else if (keyCode === _utils.KeyCode.ArrowDown) {
        newIndex = currentIndex < treeItems.length - 1 ? currentIndex + 1 : 0;
      }

      treeItems[newIndex].focus();
    }
  }, {
    key: "setKeyEventExpand",
    value: function setKeyEventExpand(keyCode, focusItem) {
      var stateObj = {};

      if (keyCode === _utils.KeyCode.ArrowLeft || keyCode === _utils.KeyCode.Space || keyCode === _utils.KeyCode.Enter) {
        stateObj = focusItem.subItems && focusItem.expanded ? {
          expanded: false
        } : {};
      } else {
        stateObj = focusItem.subItems && !focusItem.expanded ? {
          expanded: true
        } : {};
      }

      if (stateObj.expanded !== undefined) {
        this.treeStore.set(focusItem.id, stateObj);
      }
    }
  }, {
    key: "setKeyEventSelected",
    value: function setKeyEventSelected(focusItem) {
      if (focusItem === null || focusItem === void 0 ? void 0 : focusItem.selected) {
        this.treeStore.set(focusItem.id, {
          selected: false
        });
      } else if ((focusItem === null || focusItem === void 0 ? void 0 : focusItem.allowSelect) && !focusItem.selected) {
        this.treeStore.set(focusItem.id, {
          selected: true
        });
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(keyEvent) {
      var _this$shadowRoot;

      if (keyEvent.code === _utils.KeyCode.Tab) {
        return;
      }

      keyEvent.preventDefault();
      var treeItems = this.getVisibleTreeItems();
      var focusItem = ((_this$shadowRoot = this.shadowRoot) !== null && _this$shadowRoot !== void 0 ? _this$shadowRoot : document).activeElement;
      var currentIndex = focusItem ? (0, _indexOf.default)(treeItems).call(treeItems, focusItem) : 0;
      var navigationKeys = new _set.default([_utils.KeyCode.ArrowUp, _utils.KeyCode.ArrowDown, _utils.KeyCode.ArrowRight, _utils.KeyCode.ArrowLeft, _utils.KeyCode.Enter, _utils.KeyCode.Space, _utils.KeyCode.Home, _utils.KeyCode.End]);

      if (navigationKeys.has(keyEvent.code)) {
        this.handleNavigationKey(treeItems, focusItem, currentIndex, keyEvent);
        this.requestUpdate().catch(console.error);
      }
    }
  }, {
    key: "getVisibleTreeItems",
    value: function getVisibleTreeItems() {
      var _context11, _this$shadowRoot2;

      return (0, _filter.default)(_context11 = (0, _toConsumableArray2.default)(((_this$shadowRoot2 = this.shadowRoot) !== null && _this$shadowRoot2 !== void 0 ? _this$shadowRoot2 : this).querySelectorAll('bm-tree-item'))).call(_context11, function (item) {
        var _context12;

        return !(0, _includes.default)(_context12 = (0, _toConsumableArray2.default)(item.classList)).call(_context12, 'hidden');
      });
    }
  }, {
    key: "handleNavigationKey",
    value: function handleNavigationKey(treeItems, focusItem, currentIndex, keyEvent) {
      if (!focusItem && treeItems.length && keyEvent.key !== _utils.KeyCode.Enter) {
        treeItems[0].focus();
      }

      switch (keyEvent.code) {
        case _utils.KeyCode.Enter:
        case _utils.KeyCode.Space:
          this.setKeyEventSelected(focusItem);
          this.handleSelected(new CustomEvent('select', {
            detail: (0, _objectSpread2.default)({}, keyEvent)
          }));
          break;

        case _utils.KeyCode.ArrowLeft:
          this.handleArrowLeft(focusItem, treeItems, keyEvent);
          break;

        case _utils.KeyCode.ArrowRight:
          this.handleArrowRight(focusItem, treeItems, keyEvent);
          break;

        default:
          this.setKeyEventFocusForSiblingItem(keyEvent.code, treeItems, currentIndex);
          break;
      }
    }
  }, {
    key: "handleArrowLeft",
    value: function handleArrowLeft(focusItem, treeItems, keyEvent) {
      if (focusItem.subItems && !focusItem.expanded || !focusItem.subItems) {
        this.setFocusParentItem(treeItems, focusItem.parentId);
      } else if (focusItem.subItems && focusItem.expanded) {
        this.setKeyEventExpand(keyEvent.code, focusItem);
        this.handleTreeItemExpansion(focusItem, keyEvent);
      }
    }
  }, {
    key: "setFocusParentItem",
    value: function setFocusParentItem(treeItems, parentId) {
      if (parentId) {
        var parentItemIndex = (0, _findIndex.default)(treeItems).call(treeItems, function (treeItem) {
          return treeItem.id === parentId;
        });
        treeItems[parentItemIndex].focus();
      }
    }
  }, {
    key: "setFocusFirstChildItem",
    value: function setFocusFirstChildItem(treeItems, focusItem) {
      if (focusItem) {
        var currentIndex = (0, _indexOf.default)(treeItems).call(treeItems, focusItem);

        if (currentIndex >= 0 && currentIndex < treeItems.length) {
          treeItems[currentIndex + 1].focus();
        }
      }
    }
  }, {
    key: "handleArrowRight",
    value: function handleArrowRight(focusItem, treeItems, keyEvent) {
      if (focusItem.subItems && !focusItem.expanded) {
        this.setKeyEventExpand(keyEvent.code, focusItem);
        this.handleTreeItemExpansion(focusItem, keyEvent);
      } else if (focusItem.subItems && focusItem.expanded) {
        this.setFocusFirstChildItem(treeItems, focusItem);
      }
    }
  }, {
    key: "handleTreeItemExpansion",
    value: function handleTreeItemExpansion(focusItem, keyEvent) {
      if (focusItem.subItems) {
        this.setKeyEventExpand(keyEvent.code, focusItem);
        this.handleFolderExpansion(focusItem, !focusItem.expanded);
      }
    }
  }, {
    key: "handleFolderExpansion",
    value: function handleFolderExpansion(focusItem, shouldExpand) {
      var _this$treeStore$get;

      this.treeStore.set(focusItem.id, {
        expanded: shouldExpand
      });
      var details = (_this$treeStore$get = this.treeStore.get(focusItem.id)) === null || _this$treeStore$get === void 0 ? void 0 : _this$treeStore$get.details;
      this.dispatchEvent(new CustomEvent('expand', {
        detail: {
          expanded: shouldExpand,
          treeItem: details
        }
      }));
      this.requestUpdate('expanded').catch(console.error);
    }
  }, {
    key: "handleDroppedExternalItem",
    value: function handleDroppedExternalItem(e) {
      this.dispatchEvent(new CustomEvent('dropped-external-item', {
        detail: e.detail
      }));
    }
  }, {
    key: "handleDroppedMovedItem",
    value: function handleDroppedMovedItem(e) {
      this.dispatchEvent(new CustomEvent('dropped-moved-item', {
        detail: e.detail
      }));
    }
  }, {
    key: "handleChecked",
    value: function handleChecked() {
      var checked = this.treeStore.getChecked();
      this.dispatchEvent(new CustomEvent('check', {
        detail: checked
      }));
    }
  }, {
    key: "handleSelected",
    value: function handleSelected(e) {
      var selected = this.treeStore.getSelected();
      var eventData = e.detail;
      var shouldAddData = this.includeEventDataOnSelect === undefined ? this.includeMouseEventOnSelect : this.includeEventDataOnSelect;
      var detail = shouldAddData ? {
        selected: selected,
        eventData: eventData
      } : selected;
      this.dispatchEvent(new CustomEvent('select', {
        detail: detail
      }));
    }
  }, {
    key: "handleExpanded",
    value: function handleExpanded(e) {
      this.dispatchEvent(new CustomEvent('expand', {
        detail: e.detail
      }));
    }
  }, {
    key: "renderDropArea",
    value: function renderDropArea(t, i) {
      return this.html(_templateObject2(), t.parentId, i, this.treeStore, this.handleDroppedMovedItem);
    }
  }, {
    key: "renderTreeItemRepeat",
    value: function renderTreeItemRepeat() {
      var tree = this.treeStore.getAll();
      return (0, _repeatInstanceProperty(_element))((0, _filter.default)(tree).call(tree, function (t) {
        return t.visible;
      }), function (t) {
        return t;
      }, this.renderTreeItem);
    }
  }, {
    key: "renderTreeItem",
    value: function renderTreeItem(t) {
      var _t$allowSelect;

      return (0, _element.html)(_templateObject3(), this.renderDropArea(t, t.index), t.parentId && t.parentId === 'root' ? 'tree' : 'treeitem', t.layer, t.name, t.id, (0, _element.ifDefined)(t.dataQeId), t.name, t.subtitle ? t.subtitle : null, t.layer, this.showCheckboxes, this.showCheckboxes && (t.showCheckBox || typeof t.showCheckBox !== 'boolean'), this.selectAsCheck, (_t$allowSelect = t.allowSelect) !== null && _t$allowSelect !== void 0 ? _t$allowSelect : typeof t.allowSelect !== 'boolean', t.children && t.children.length > 0, t.leftIcon ? t.leftIcon : null, t.rightIcon ? t.rightIcon : null, t.href, this.treeStore, this.allowDragAndDrop || t.allowItemDrag, this.allowDragAndDrop || t.allowDropInto, t.index, this.handleSelected, this.handleChecked, this.handleExpanded, this.handleDroppedExternalItem, this.handleDroppedMovedItem, this.handleError);
    }
  }, {
    key: "render",
    value: function render() {
      return this.html(_templateObject4(), this.renderTreeItemRepeat());
    }
  }]);
  return BmTree;
}(_element.BlueElement);

exports.BmTree = BmTree;

var registerTree = function registerTree() {
  (0, _bmTreeItem.registerTreeItem)();
  (0, _bmTreeDropArea.registerTreeDropArea)();
  (0, _element.register)(BmTree);
};

exports.registerTree = registerTree;
